import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            padding: '25px 30px 0px 30px !important'
        },
        welcomeText: {
            fontSize: '24px !important',
            lineHeight: '28px',
            fontWeight: '600 !important',
            marginBottom: '5px !important'
        },
    }),
);

export default useStyles;